module.exports = __webpack_public_path__ + "static/Counselors-List-English-0b7e1edf229bac3cc6a9d14c1fcbb744.pdf";